import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { merge } from 'es-toolkit';
import {map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {BaseService} from '../../../../shared/src/lib/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class PreCERCLISService extends BaseService {
  public item: any = {};
  public meta: any = {};
  notesService: BaseService;

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/precerclis/sites`, http);
    this.notesService = new BaseService(`${environment.baseUrl}/precerclis/notes`, http);
  }

  loadData(searchObj): Observable<any> {
    return this.getList<any>(searchObj).pipe(tap(item => {
      if (item.results[0]) {
        merge(this.item, item.results[0]);
      } else {
        this.item = {};
      }

      merge(this.meta, item.meta);
      this.meta.display_fields = ['exposurepathway', 'circumstances', 'source'];
      this.meta.type = 'precerclis/sites';
      this.meta.urlPath = 'this';
      this.meta.subItems = ['notes', 'attachments'];

      this.meta.fields.notes.verbose_name_plural = 'Notes';
      this.meta.fields.notes.verbose_name = 'Note';
      this.meta.fields.notes.foreign_key_field = 'precerclissite';
      this.meta.fields.notes.display_fields = [
        'text', 'created_date', 'created_user', 'last_edited_date', 'last_edited_user'
      ];

      this.meta.fields.notes.type = 'precerclis/notes';
      this.meta.fields.attachments = {type: 'precerclis/attachments'};
    }));
  }
}
